// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"031c15b9","455":"5ddf53e5","488":"853264c2","774":"3f0e63f2"}[chunkId] + ".chunk.js";
};